import type { ReactNode } from 'react';
import type { useAdvisorDnd } from './use-advisor-dnd';
import { DndContext, DragOverlay } from '@dnd-kit/core';
import { ImageOff } from 'lucide-react';
import { Text } from '@/shared/ui/text';
import css from './advisor-planner-workspace.module.scss';

type DragPreview = NonNullable<ReturnType<typeof useAdvisorDnd>['preview']>;

type AdvisorDndShellProps = {
  dnd: ReturnType<typeof useAdvisorDnd>;
  children: ReactNode;
  /** The layout's own card under the pointer; the console's by default. */
  renderPreview?: (preview: DragPreview) => ReactNode;
};

/** Drag context and the card that follows the pointer, shared by layouts. */
export const AdvisorDndShell = ({
  dnd,
  children,
  renderPreview,
}: AdvisorDndShellProps) => (
  <DndContext
    collisionDetection={dnd.collisionDetection}
    onDragCancel={dnd.onDragCancel}
    onDragEnd={dnd.onDragEnd}
    onDragStart={dnd.onDragStart}
    sensors={dnd.sensors}
  >
    {children}
    <DragOverlay>
      {dnd.preview && renderPreview ? (
        renderPreview(dnd.preview)
      ) : dnd.preview ? (
        <div className={css.dragPreview}>
          {dnd.preview.thumbnail ? (
            <img
              alt=""
              className={css.dragPreviewThumb}
              src={dnd.preview.thumbnail}
            />
          ) : (
            <ImageOff aria-hidden="true" size={16} />
          )}
          <Text as="span" size="sm" weight="medium">
            {dnd.preview.title}
          </Text>
        </div>
      ) : null}
    </DragOverlay>
  </DndContext>
);
